import React from "react";
import Header from "./Header/header";
import Notification from "./Notification/notification";
import Loading from "./Loading/loading";
import DeclinePage from "./DeclinePage/decline.page";
import ApplicationDecisionPage from "./ApplicationDecisionPage/applicationDecisionPage";
import VeridPage from "./VeridPage/veridPage";
import defaultScrollToTop from "../utils/scroll";
import { isLoading, getStep, getFocus } from "../selectors";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const content = {
  decline: (step, dispatch, appComponent) => [
    <Header key="header" />,
    <DeclinePage key="declinePage" focusableRef={(el) => { appComponent.focusableRef = el; }} />
  ],
  applicationPended: (step, dispatch, appComponent) => [
    <Header key="header" focusableRef={(el) => { appComponent.focusableRef = el; }}/>,
    <ApplicationDecisionPage key="PendedPage"/>
  ],
  verid: (step, dispatch, appComponent) => [
    <Header key="header" focusableRef={(el) => { appComponent.focusableRef = el; }}/>,
    <VeridPage key="veridPage"/>
  ],
  applicationApproved: (step, dispatch, appComponent) => [
    <Header key="header" focusableRef={(el) => { appComponent.focusableRef = el; }}/>,
    <ApplicationDecisionPage key="ApprovedPage"/>
  ]
};

export class App extends React.Component {

  componentDidUpdate(prevProps) {
    (this.props.scrollToTop || defaultScrollToTop)(this);
    if (this.focusableRef && prevProps.focus !== this.props.focus) {
      this.focusableRef.focus();
    }
  }

  render() {
    return (
      <div>
        { content[this.props.step](this.props.step, this.props.dispatch, this) }
        <Notification dispatch={this.props.dispatch}/>
        { this.props.isLoading && <Loading/> }
      </div>
    );
  }
}

App.propTypes = {
  step: PropTypes.string.isRequired,
  isLoading: PropTypes.bool
};

export default connect(
  state => ({
    step: getStep(state),
    isLoading: isLoading(state),
    focus: getFocus(state)
  }),
  dispatch => ({ dispatch })
)(App);
